/**
 * Docs Awaiting OCR — client for the Data Specialist WorkDesk panel.
 * Backend: backend/app/api/v1/queue_api.py (/queue/docs-awaiting-ocr*).
 */
import { api } from '@/utils/api';

export type OcrRetryBlockedReason = 'processing' | 'not_retryable' | 'retry_limit' | 'image';

export interface DocAwaitingOcr {
  uploadId: string;
  filename: string;
  caseId: string | null;
  clientName: string | null;
  status: string;
  processingStage: string | null;
  errorMessage: string | null;
  updatedAt: string | null;
  ageMinutes: number | null;
  stalled: boolean;
  category: string | null;
  suggestedRemediation: string | null;
  processingAttempts: number;
  retryable: boolean;
  retryBlockedReason: OcrRetryBlockedReason | null;
}

export interface DocsAwaitingOcrList {
  items: DocAwaitingOcr[];
  total: number;
}

export async function fetchDocsAwaitingOcr(limit = 50): Promise<DocsAwaitingOcrList> {
  const res = await api.get<any>(`/api/v1/queue/docs-awaiting-ocr?limit=${limit}`);
  const items: DocAwaitingOcr[] = (res?.items ?? []).map((r: any) => ({
    uploadId: r.upload_id,
    filename: r.filename,
    caseId: r.case_id ?? null,
    clientName: r.client_name ?? null,
    status: r.status,
    processingStage: r.processing_stage ?? null,
    errorMessage: r.error_message ?? null,
    updatedAt: r.updated_at ?? null,
    ageMinutes: r.age_minutes ?? null,
    stalled: !!r.stalled,
    category: r.category ?? null,
    suggestedRemediation: r.suggested_remediation ?? null,
    processingAttempts: r.processing_attempts ?? 0,
    retryable: !!r.retryable,
    retryBlockedReason: r.retry_blocked_reason ?? null,
  }));
  return { items, total: res?.total ?? items.length };
}

export async function retryDocOcr(uploadId: string): Promise<{ queued: boolean }> {
  const res = await api.post<any>(`/api/v1/queue/docs-awaiting-ocr/${encodeURIComponent(uploadId)}/retry`);
  return { queued: !!res?.queued };
}

export async function dismissDocOcr(uploadId: string, reason?: string): Promise<{ dismissed: boolean }> {
  const res = await api.post<any>(
    `/api/v1/queue/docs-awaiting-ocr/${encodeURIComponent(uploadId)}/dismiss`,
    reason ? { reason } : {},
  );
  return { dismissed: !!res?.dismissed };
}
